module.exports = {"ORTPAD-1":"Session ended. User has been logged out.","DEFAULT":"Unknown Error. Applications has been restarted."}